/**
 * Micro-helper per il DOM: riducono il rumore nei moduli di rendering.
 */

/**
 * @param {string} selector
 * @param {ParentNode} [scope=document]
 * @returns {HTMLElement|null}
 */
export const qs = (selector, scope = document) => scope.querySelector(selector);

/**
 * Crea un elemento con attributi e figli in una sola chiamata.
 *
 * Il testo viene sempre inserito con `textContent`: i titoli arrivano da una
 * fonte esterna e non devono mai essere interpretati come HTML.
 *
 * @param {string} tag
 * @param {Record<string, any>} [attrs] attributi (`class`, `text`, `html`, dataset, aria…)
 * @param {Array<Node|string>} [children]
 * @returns {HTMLElement}
 */
export function el(tag, attrs = {}, children = []) {
  const node = document.createElement(tag);

  for (const [key, value] of Object.entries(attrs)) {
    if (value === undefined || value === null || value === false) continue;

    if (key === 'class') node.className = value;
    else if (key === 'text') node.textContent = value;
    else if (key === 'dataset') Object.assign(node.dataset, value);
    else if (key.startsWith('on') && typeof value === 'function') {
      node.addEventListener(key.slice(2).toLowerCase(), value);
    } else node.setAttribute(key, value === true ? '' : String(value));
  }

  for (const child of children) {
    node.append(child instanceof Node ? child : document.createTextNode(String(child)));
  }

  return node;
}

/**
 * Mostra o nasconde un elemento tramite l'attributo `hidden`.
 *
 * @param {HTMLElement|null} node
 * @param {boolean} visible
 */
export function toggleVisibility(node, visible) {
  if (!node) return;
  node.hidden = !visible;
}

/**
 * Esegue una funzione al massimo una volta ogni `delay` ms di inattività.
 * Usato sull'input di ricerca per non ridisegnare la lista a ogni tasto.
 *
 * @param {Function} fn
 * @param {number} [delay=250]
 * @returns {Function}
 */
export function debounce(fn, delay = 250) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}
